import styled from 'styled-components';

export const MrdDeviceWizardStyle = styled.div`
  .add-mrd-container{
    padding: 40px;
  }
  .add-mrd-container-title{
    font-family: 'Open Sans', sans-serif;
    font-size: 20px;
    font-weight: bold;
  }

  .add-mrd-container-buttons{
    margin: 10px 30px;
    min-width: 940px;
  }

  .add-mrd-container-body{
    background-color: white;
    border: solid 1px;
    min-width: 1000px;
  }

  .save-label{
    width: 280px;
    height: 30px;
    display: grid;
    align-content: center;
  }

  .right-alignment{
    float: right;
  }
`;
